import api from "../services/api-service";

class QuizConfigurationService {
  createConfiguration(body) {
    try {
      return api.post({
        url: "quiz-configurations/create-configuration",
        body,
      });
    } catch (error) {
      return new Error(error);
    }
  }
  getAllConfigurations(instructor_id, search, is_count_needed = false, page, limit, niche_id) {
    try {
      return api.get({
        url: "quiz-configurations/get-all-configurations",
        params: {
          created_by: instructor_id,
          search,
          is_count_needed,
          page,
          limit,
          niche_id
        },
      });
    } catch (error) {
      return new Error(error);
    }
  }
  updateConfiguration(id, body) {
    try {
      return api.put({
        url: `quiz-configurations/update-configuration/${id}`,
        body,
      });
    } catch (error) {
      return new Error(error);
    }
  }
  deleteConfiguration(id, body) {
    console.log(id, body)
    try {
      return api.delete({
        url: `quiz-configurations/delete-configuration/${id}`,
        body,
      });
    } catch (error) {
      return new Error(error);
    }
  }
  getConfiguration(id, is_count_needed = false) {
    try {
      let url = `quiz-configurations/get-configuration/${Array.isArray(id) ? id[0] : id}?`;
      if (Array.isArray(id)) {
        id.forEach(sid => {
          url += `configuration_id[]=${sid}&`;
        });
      }
      url += `is_count_needed=${is_count_needed}`;
      
      return api.get({
        url: url.endsWith('&') ? url.slice(0, -1) : url,
      });
    } catch (error) {
      return new Error(error);
    }
  }
  getConfigurations(ids, is_count_needed = false) {
    try {
      let url = "quiz-configurations/get-all-configurations?";
      if (Array.isArray(ids)) {
        ids.forEach(id => {
          url += `configuration_id[]=${id}&`;
        });
      }
      url += `is_count_needed=${is_count_needed}&limit=${ids.length || 100}`;
      
      return api.get({
        url: url.endsWith('&') ? url.slice(0, -1) : url,
      });
    } catch (error) {
      return new Error(error);
    }
  }
  getCourseTags() {
    try {
      return api.get({
        url: "coursetag/get",
        server: "main",
      });
    } catch (error) {
      return new Error(error);
    }
  }
  /** Province → boards → programs tree from LMS (public). */
  getBoardSelection() {
    try {
      return api.get({
        url: "boards/get-board-selection",
        server: "lms",
      });
    } catch (error) {
      return new Error(error);
    }
  }
}
export default new QuizConfigurationService();
